<template>
  <el-dialog
    :title="$t('editComplaintType.title')"
    :visible.sync="visible"
    width="650px"
    :close-on-click-modal="false"
    @close="handleClose"
    custom-class="complaint-type-modal"
  >
    <div class="modal-header">
      <span class="modal-title">{{ $t('editComplaintType.title') }}</span>
    </div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="86px"
      class="complaint-type-form"
    >
      <el-form-item :label="$t('editComplaintType.community')" prop="communityId" required>
        <el-select
          v-model="form.communityId"
          :placeholder="$t('editComplaintType.communityPlaceholder')"
          style="width: 516px"
        >
          <el-option
            v-for="item in communityList"
            :key="item.communityId"
            :label="item.name"
            :value="item.communityId"
          />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('editComplaintType.typeName')" prop="typeName" required>
        <el-input
          v-model="form.typeName"
          :placeholder="$t('editComplaintType.typeNamePlaceholder')"
          style="width: 516px"
        />
      </el-form-item>

      <el-form-item :label="$t('editComplaintType.notifyWay')" prop="notifyWay" required>
        <el-select
          v-model="form.notifyWay"
          :placeholder="$t('editComplaintType.notifyWayPlaceholder')"
          style="width: 516px"
        >
          <el-option
            v-for="item in notifyWayOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('editComplaintType.appraiseReply')" prop="appraiseReply" required>
        <el-select
          v-model="form.appraiseReply"
          :placeholder="$t('editComplaintType.appraiseReplyPlaceholder')"
          style="width: 516px"
        >
          <el-option
            v-for="item in appraiseReplyOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('editComplaintType.remark')" prop="remark">
        <el-input
          v-model="form.remark"
          :placeholder="$t('editComplaintType.remarkPlaceholder')"
          style="width: 516px"
        />
      </el-form-item>

      <el-form-item :label="$t('editComplaintType.selectStaff')" prop="staffs" required>
        <el-select
          v-model="selectedStaffIds"
          :placeholder="$t('editComplaintType.selectStaff')"
          style="width: 516px"
          multiple
          filterable
          clearable
          :loading="staffLoading"
          @change="handleStaffChange"
        >
          <el-option
            v-for="item in staffOptions"
            :key="item.userId"
            :label="formatStaffName(item)"
            :value="item.userId"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button class="cancel-btn" @click="visible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button class="save-btn" type="primary" @click="handleSubmit" :loading="loading">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateComplaintType, getComplaintTypeDetail, getStaffInfos } from '@/api/oa/editComplaintTypeApi'
import { getEffectiveCommunityId, getMyEnteredCommunitys, normalizeCommunityId } from '@/api/community/communityApi'

export default {
  name: 'EditComplaintTypeModal',
  data() {
    return {
      visible: false,
      loading: false,
      staffLoading: false,
      communityId: '',
      communityList: [],
      staffOptions: [],
      selectedStaffIds: [],
      form: {
        typeCd: '',
        communityId: '',
        typeName: '',
        notifyWay: '',
        appraiseReply: '',
        remark: '',
        staffs: []
      },
      notifyWayOptions: [
        { value: 'SMS', label: this.$t('editComplaintType.sms') },
        { value: 'WECHAT', label: this.$t('editComplaintType.wechat') },
        { value: 'WORK_LICENSE', label: this.$t('editComplaintType.workLicense') }
      ],
      appraiseReplyOptions: [
        { value: 'Y', label: this.$t('editComplaintType.autoReply') },
        { value: 'N', label: this.$t('editComplaintType.manualReply') }
      ],
      rules: {
        communityId: [
          { required: true, message: this.$t('editComplaintType.communityRequired'), trigger: 'change' }
        ],
        typeName: [
          { required: true, message: this.$t('editComplaintType.typeNameRequired'), trigger: 'blur' }
        ],
        notifyWay: [
          { required: true, message: this.$t('editComplaintType.notifyWayRequired'), trigger: 'change' }
        ],
        appraiseReply: [
          { required: true, message: this.$t('editComplaintType.appraiseReplyRequired'), trigger: 'change' }
        ],
        staffs: [
          { required: true, type: 'array', min: 1, message: this.$t('editComplaintType.selectStaff'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    async open(row) {
      this.communityId = normalizeCommunityId(row.communityId)
      this.form.typeCd = row.typeCd
      await this.loadCommunityList()
      await this.loadStaffOptions()
      await this.loadComplaintTypeDetail()
      this.visible = true
    },
    async loadCommunityList() {
      try {
        const res = await getMyEnteredCommunitys({ page: 1, row: 1000 })
        this.communityList = (res.communitys || []).filter(item => getEffectiveCommunityId(item.communityId))
      } catch (error) {
        console.error('获取小区列表失败:', error)
      }
    },
    async loadComplaintTypeDetail() {
      try {
        const params = {
          typeCd: this.form.typeCd,
          page: 1,
          row: 1
        }
        const { data } = await getComplaintTypeDetail(params)
        if (data && data.length > 0) {
          const detail = data[0]
          this.form = {
            typeCd: detail.typeCd,
            communityId: getEffectiveCommunityId(detail.communityId || this.communityId),
            typeName: detail.typeName,
            notifyWay: detail.notifyWay,
            appraiseReply: detail.appraiseReply,
            remark: detail.remark,
            staffs: detail.staffs || []
          }
          this.mergeSelectedStaffOptions(detail.staffs || [])
          this.selectedStaffIds = (detail.staffs || []).map(staff => String(staff.staffId || staff.userId)).filter(Boolean)
          this.handleStaffChange(this.selectedStaffIds)
        }
      } catch (error) {
        this.$message.error(this.$t('editComplaintType.loadError'))
      }
    },
    async loadStaffOptions() {
      this.staffLoading = true
      try {
        const { staffs } = await getStaffInfos({ page: 1, row: 1000 })
        this.staffOptions = (staffs || []).map(item => ({
          ...item,
          userId: String(item.userId),
          userName: item.userName || item.name
        }))
      } catch (error) {
        this.$message.error(error.message || this.$t('editComplaintType.loadError'))
      } finally {
        this.staffLoading = false
      }
    },
    formatStaffName(staff) {
      const name = staff.name || staff.userName || staff.staffName || staff.userId
      return staff.tel ? `${name}（${staff.tel}）` : name
    },
    mergeSelectedStaffOptions(staffs) {
      const staffMap = new Map(this.staffOptions.map(item => [String(item.userId), item]))
      ;(staffs || []).forEach(staff => {
        const userId = String(staff.staffId || staff.userId || '')
        if (!userId || staffMap.has(userId)) {
          return
        }
        staffMap.set(userId, {
          userId,
          userName: staff.staffName || staff.name || userId,
          name: staff.staffName || staff.name || userId,
          tel: staff.tel
        })
      })
      this.staffOptions = Array.from(staffMap.values())
    },
    handleStaffChange(staffIds) {
      this.form.staffs = (staffIds || []).map(staffId => {
        const staff = this.staffOptions.find(item => String(item.userId) === String(staffId))
        return {
          userId: String(staffId),
          name: staff ? (staff.userName || staff.name || staff.staffName) : String(staffId)
        }
      })
      this.$refs.form && this.$refs.form.validateField('staffs')
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        try {
          this.loading = true
          this.handleStaffChange(this.selectedStaffIds)
          await updateComplaintType(this.form)
          this.$message.success(this.$t('common.operationSuccess'))
          this.$emit('success')
          this.visible = false
        } catch (error) {
          this.$message.error(error.message || this.$t('editComplaintType.saveError'))
        } finally {
          this.loading = false
        }
      })
    },
    handleClose() {
      this.$refs.form && this.$refs.form.resetFields()
      this.selectedStaffIds = []
      this.staffOptions = []
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .complaint-type-modal {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__footer {
    padding: 24px;
    border-top: 1px solid #EBF2FA;
  }
}

.modal-header {
  height: 66px;
  background: #EBF2FA;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  border-bottom: 1px solid #DCE6F5;

  .modal-title {
    font-size: 16px;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 600;
    color: #1D2129;
  }
}

.complaint-type-form {
  padding: 24px 24px 0;

  ::v-deep .el-form-item__label {
    font-size: 14px;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 500;
    color: #1D2129;
    text-align: right;
    padding-right: 8px;

    &::before {
      color: #FB2C36;
      margin-right: 2px;
    }
  }

  ::v-deep .el-input__inner,
  ::v-deep .el-textarea__inner {
    border-radius: 10px;
    border: 1px solid #DCE6F5;
    font-size: 14px;
    font-family: 'Inter', 'PingFang SC', sans-serif;
    color: #1D2129;

    &::placeholder {
      color: #8C9BB4;
    }

    &:focus {
      border-color: #0E76FF;
    }
  }

  ::v-deep .el-input__inner {
    height: 38px;
    line-height: 38px;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .cancel-btn {
    width: 98px;
    height: 38px;
    border-radius: 10px;
    border: 1px solid #0E76FF;
    background: #FFFFFF;
    color: #0E76FF;
    font-size: 14px;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 500;

    &:hover {
      background: #E8F3FF;
    }
  }

  .save-btn {
    width: 98px;
    height: 38px;
    border-radius: 10px;
    background: #0E76FF;
    border: none;
    color: #FFFFFF;
    font-size: 14px;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 500;

    &:hover {
      background: #1C99FF;
    }
  }
}
</style>
